import { createEvent, createStore, sample } from 'effector';
import {
  SEARCH_BY_PARAMS_LOCAL_STORAGE_KEY,
  SEARCH_BY_RANGES_LOCAL_STORAGE_KEY,
} from '../constants';
import { isEqual } from 'lodash-es';
import { useStore } from 'effector-react';
import { $agriculture } from '@/modules/agriculture/store/agriculture.store';

const wheat = $agriculture.getState().find((item) => item.id === 1);
const wheatRanges = {
  gluten: wheat?.parameters.find((item) => item.id === 1),
  humidity: wheat?.parameters.find((item) => item.id === 2),
  idk: wheat?.parameters.find((item) => item.id === 3),
  cp: wheat?.parameters.find((item) => item.id === 4),
  protein: wheat?.parameters.find((item) => item.id === 5),
  nature: wheat?.parameters.find((item) => item.id === 6),
};
export const searchInitialState = {
  stores: [],
  rangesData: {
    year: [
      (new Date().getFullYear() - 5).toString(),
      new Date().getFullYear().toString(),
    ],
    gluten: [
      wheatRanges.gluten?.options.min?.toString() || '6',
      wheatRanges.gluten?.options.max?.toString() || '55',
    ],
    idk: [
      wheatRanges.idk?.options.min?.toString() || '10',
      wheatRanges.idk?.options.max?.toString() || '110',
    ],
    clop: ['0', '100'],
    protein: [
      wheatRanges.protein?.options.min?.toString() || '5',
      wheatRanges.protein?.options.max?.toString() || '20',
    ],
    cp: [
      wheatRanges.cp?.options.min?.toString() || '60',
      wheatRanges.cp?.options.max?.toString() || '280',
    ],
    nature: [
      wheatRanges.nature?.options.min?.toString() || '350',
      wheatRanges.nature?.options.max?.toString() || '900',
    ],
    humidity: [
      wheatRanges.humidity?.options.min?.toString() || '6',
      wheatRanges.humidity?.options.max?.toString() || '30',
    ],
  },
  wheatData: {
    sort: '',
    type: '',
    divergence: 0,
    year: new Date().getFullYear(),
    class: 0,
    params: {
      gluten: 0,
      idk: 0,
      clop: 0,
      protein: 0,
      cp: 0,
      nature: 0,
      humidity: 0,
    },
  },
};

const cachedSearchState = localStorage.getItem(SEARCH_BY_PARAMS_LOCAL_STORAGE_KEY);
const parsed = cachedSearchState ? JSON.parse(cachedSearchState) : null;

export const setWarehousesToSearchByParams = createEvent<ISearchState>();
export const setValuesToSearchByParams = createEvent<ISearchState>();
export const setSpecificRangeValue = createEvent<{
  fieldName: string;
  val: [string, string];
}>();

export const $searchByParams = createStore<ISearchState>(parsed || searchInitialState);

$searchByParams.on(setWarehousesToSearchByParams, (_s, p) => p);

$searchByParams.on(setValuesToSearchByParams, (_s, p) => {
  if (isEqual(p, searchInitialState)) return;
  localStorage.setItem(SEARCH_BY_PARAMS_LOCAL_STORAGE_KEY, JSON.stringify(p));
  return p;
});

$searchByParams.on(setSpecificRangeValue, (s, p) => {
  const newVal = { ...s };
  // @ts-ignore
  newVal.rangesData[p.fieldName] = p.val;
  localStorage.setItem(SEARCH_BY_PARAMS_LOCAL_STORAGE_KEY, JSON.stringify(newVal));
  return newVal;
});

const cachedRangesSearchState = localStorage.getItem(
  SEARCH_BY_RANGES_LOCAL_STORAGE_KEY,
);
const parsedRanges = cachedRangesSearchState
  ? JSON.parse(cachedRangesSearchState)
  : null;

export const setWarehousesToSearchByRanges = createEvent<ISearchState>();
export const setValuesToSearchByRanges = createEvent<ISearchState>();

export const $searchByRanges = createStore<ISearchState>(
  parsedRanges || searchInitialState,
);

$searchByRanges.on(setWarehousesToSearchByRanges, (_s, p) => p);

$searchByRanges.on(setValuesToSearchByRanges, (_s, p) => {
  if (isEqual(p, searchInitialState)) return;
  localStorage.setItem(SEARCH_BY_RANGES_LOCAL_STORAGE_KEY, JSON.stringify(p));
  return p;
});

$searchByRanges.on(setSpecificRangeValue, (s, p) => {
  const newVal = { ...s };
  // @ts-ignore
  newVal.rangesData[p.fieldName] = p.val;
  localStorage.setItem(SEARCH_BY_RANGES_LOCAL_STORAGE_KEY, JSON.stringify(newVal));
  return newVal;
});

// sample({
//   // @ts-ignore
//   clock: $agriculture.updates,
//   fn: (agriculture) => {
//     const wheat = agriculture.find((item) => item.id === 1);
//     const wheatRanges = {
//       gluten: wheat?.parameters.find((item) => item.id === 1),
//       humidity: wheat?.parameters.find((item) => item.id === 2),
//       idk: wheat?.parameters.find((item) => item.id === 3),
//       cp: wheat?.parameters.find((item) => item.id === 4),
//       protein: wheat?.parameters.find((item) => item.id === 5),
//       nature: wheat?.parameters.find((item) => item.id === 6),
//     };

//     return {
//       stores: [],
//       rangesData: {
//         year: [
//           (new Date().getFullYear() - 5).toString(),
//           new Date().getFullYear().toString(),
//         ],
//         gluten: [
//           wheatRanges.gluten?.options.min?.toString() || '0',
//           wheatRanges.gluten?.options.max?.toString() || '1000',
//         ],
//         idk: [
//           wheatRanges.idk?.options.min?.toString() || '0',
//           wheatRanges.idk?.options.max?.toString() || '1000',
//         ],
//         clop: ['0', '1000'],
//         protein: [
//           wheatRanges.protein?.options.min?.toString() || '0',
//           wheatRanges.protein?.options.max?.toString() || '1000',
//         ],
//         cp: [
//           wheatRanges.cp?.options.min?.toString() || '0',
//           wheatRanges.cp?.options.max?.toString() || '1000',
//         ],
//         nature: [
//           wheatRanges.nature?.options.min?.toString() || '0',
//           wheatRanges.nature?.options.max?.toString() || '1000',
//         ],
//         humidity: [
//           wheatRanges.humidity?.options.min?.toString() || '0',
//           wheatRanges.humidity?.options.max?.toString() || '1000',
//         ],
//       },
//       wheatData: {
//         sort: '',
//         type: '',
//         divergence: 0,
//         year: new Date().getFullYear(),
//         class: 0,
//         params: {
//           gluten: 0,
//           idk: 0,
//           clop: 0,
//           protein: 0,
//           cp: 0,
//           nature: 0,
//           humidity: 0,
//         },
//       },
//     };
//   },
//   target: setValuesToSearchByParams,
// });

interface ISearchState {
  stores: { id: number; checked: boolean; label: string }[];
  rangesData: {
    year: [string, string];
    gluten: [string, string];
    idk: [string, string];
    clop: [string, string];
    protein: [string, string];
    cp: [string, string];
    nature: [string, string];
    humidity: [string, string];
  };
  wheatData: {
    sort: string;
    type: string;
    divergence: number;
    year: number;
    class: number;
    params: {
      gluten: number;
      idk: number;
      clop: number;
      protein: number;
      cp: number;
      nature: number;
      humidity: number;
    };
  };
}
